import type { Approval } from '@/api/types'

/**
 * 审批 Mock 数据
 * K8决策: 单级审批数据模型
 *
 * 类型-类目映射:
 *   合同(CONTRACT): TRANSFER(转校) / CONTRACT_SIGN(签署) / CONTRACT_TERMINATE(终止)
 *   会员卡(MEMBERSHIP): ISSUE_CARD(办卡) / REFUND_CARD(退卡) / FREEZE_CARD(冻结) / UNFREEZE_CARD(解冻)
 *   课程(COURSE): COURSE_ENROLL(报名) / COURSE_TRANSFER(转课) / COURSE_DROP(退课) / LEAVE(请假)
 *   财务(FINANCE): REFUND(退费) / DISCOUNT(折扣) / EXPENSE(报销) / OTHER(其他)
 *
 * 状态: PENDING / APPROVED / REJECTED / WITHDRAWN
 *
 * 审批逻辑:
 *   - ISSUE_CARD: 审批前EntitlementAccount=PENDING_APPROVAL，不生成账单；通过后→ACTIVE+生成账单
 *   - 审批通过 → triggerDownstream 推进原数据状态
 *   - 审批拒绝 → 通知申请人，可修改后重新发起
 *   - 已同意可撤回 → withdrawDownstream 回滚原数据状态
 */

export const mockApprovals: Approval[] = [
  // ===== 财务审批 =====
  {
    id: 'ap-001',
    brandId: 'b-001',
    campusId: 'c-001',
    type: 'REFUND',
    category: 'FINANCE',
    targetId: 'cu-001',
    studentId: 'cu-001',
    studentPhone: '13900000001',
    familyGroupId: 'fg-001',
    applicantId: 'u-consultant-001',
    amountMinor: 30000,
    currency: 'CNY',
    status: 'PENDING',
    decidedBy: null,
    decidedAt: null,
    comment: null,
    createdAt: '2025-10-20T09:00:00+08:00',
    updatedAt: '2025-10-20T09:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'ap-002',
    brandId: 'b-001',
    campusId: 'c-002',
    type: 'DISCOUNT',
    category: 'FINANCE',
    targetId: 'cu-003',
    studentId: 'cu-003',
    studentPhone: '13900000020',
    familyGroupId: 'fg-002',
    applicantId: 'u-consultant-001',
    amountMinor: 88000,
    currency: 'CNY',
    status: 'PENDING',
    decidedBy: null,
    decidedAt: null,
    comment: null,
    createdAt: '2025-10-21T10:30:00+08:00',
    updatedAt: '2025-10-21T10:30:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'ap-005',
    brandId: 'b-001',
    campusId: 'c-002',
    type: 'EXPENSE',
    category: 'FINANCE',
    targetId: 'cu-003',
    studentId: 'cu-003',
    studentPhone: '13900000020',
    familyGroupId: 'fg-002',
    applicantId: 'u-principal-001',
    amountMinor: 50000,
    currency: 'CNY',
    status: 'APPROVED',
    decidedBy: 'u-boss-001',
    decidedAt: '2025-10-18T16:00:00+08:00',
    comment: '同意采购，请注意控制预算。',
    createdAt: '2025-10-17T10:00:00+08:00',
    updatedAt: '2025-10-18T16:00:00+08:00',
    createdBy: 'u-principal-001',
    updatedBy: 'u-boss-001',
  },
  {
    id: 'ap-006',
    brandId: 'b-001',
    campusId: 'c-001',
    type: 'REFUND',
    category: 'FINANCE',
    targetId: 'cu-004',
    studentId: 'cu-004',
    studentPhone: '13900000021',
    applicantId: 'u-consultant-001',
    amountMinor: 30000,
    currency: 'CNY',
    status: 'APPROVED',
    decidedBy: 'u-principal-001',
    decidedAt: '2025-10-15T11:00:00+08:00',
    comment: '同意退款，已核算未消耗课时。',
    createdAt: '2025-10-14T14:00:00+08:00',
    updatedAt: '2025-10-15T11:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-principal-001',
  },
  {
    id: 'ap-007',
    brandId: 'b-001',
    campusId: 'c-003',
    type: 'DISCOUNT',
    category: 'FINANCE',
    targetId: 'cu-005',
    studentId: 'cu-005',
    studentPhone: '13900000022',
    familyGroupId: 'fg-003',
    applicantId: 'u-principal-001',
    amountMinor: 120000,
    currency: 'CNY',
    status: 'REJECTED',
    decidedBy: 'u-boss-001',
    decidedAt: '2025-10-19T17:00:00+08:00',
    comment: '折扣力度过大，请重新评估后申请。',
    createdAt: '2025-10-18T09:00:00+08:00',
    updatedAt: '2025-10-19T17:00:00+08:00',
    createdBy: 'u-principal-001',
    updatedBy: 'u-boss-001',
  },

  // ===== 合同审批 =====
  {
    id: 'ap-003',
    brandId: 'b-001',
    campusId: 'c-001',
    type: 'TRANSFER',
    category: 'CONTRACT',
    targetId: 'cu-001',
    studentId: 'cu-001',
    studentPhone: '13900000001',
    familyGroupId: 'fg-001',
    applicantId: 'u-principal-001',
    amountMinor: 0,
    currency: 'CNY',
    status: 'PENDING',
    decidedBy: null,
    decidedAt: null,
    comment: null,
    createdAt: '2025-10-22T14:00:00+08:00',
    updatedAt: '2025-10-22T14:00:00+08:00',
    createdBy: 'u-principal-001',
    updatedBy: 'u-principal-001',
  },

  // ===== 会员卡审批 =====
  {
    id: 'ap-008',
    brandId: 'b-001',
    campusId: 'c-001',
    type: 'ISSUE_CARD',
    category: 'MEMBERSHIP',
    targetId: 'cu-007',
    studentId: 'cu-007',
    studentPhone: '13900000024',
    applicantId: 'u-consultant-001',
    amountMinor: 128000,
    currency: 'CNY',
    status: 'PENDING',
    decidedBy: null,
    decidedAt: null,
    comment: null,
    createdAt: '2025-10-23T09:00:00+08:00',
    updatedAt: '2025-10-23T09:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'ap-009',
    brandId: 'b-001',
    campusId: 'c-002',
    type: 'REFUND_CARD',
    category: 'MEMBERSHIP',
    targetId: 'cu-003',
    studentId: 'cu-003',
    studentPhone: '13900000020',
    familyGroupId: 'fg-002',
    applicantId: 'u-consultant-001',
    amountMinor: 60000,
    currency: 'CNY',
    status: 'PENDING',
    decidedBy: null,
    decidedAt: null,
    comment: null,
    createdAt: '2025-10-23T11:00:00+08:00',
    updatedAt: '2025-10-23T11:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'ap-010',
    brandId: 'b-001',
    campusId: 'c-001',
    type: 'FREEZE_CARD',
    category: 'MEMBERSHIP',
    targetId: 'cu-001',
    studentId: 'cu-001',
    studentPhone: '13900000001',
    familyGroupId: 'fg-001',
    applicantId: 'u-principal-001',
    amountMinor: 0,
    currency: 'CNY',
    status: 'APPROVED',
    decidedBy: 'u-boss-001',
    decidedAt: '2025-10-20T15:00:00+08:00',
    comment: '同意冻结，原因是学员请假一个月。',
    createdAt: '2025-10-19T14:00:00+08:00',
    updatedAt: '2025-10-20T15:00:00+08:00',
    createdBy: 'u-principal-001',
    updatedBy: 'u-boss-001',
  },

  // ===== 课程审批 =====
  {
    id: 'ap-011',
    brandId: 'b-001',
    campusId: 'c-001',
    type: 'COURSE_ENROLL',
    category: 'COURSE',
    targetId: 'cu-007',
    studentId: 'cu-007',
    studentPhone: '13900000024',
    applicantId: 'u-consultant-001',
    amountMinor: 88000,
    currency: 'CNY',
    status: 'PENDING',
    decidedBy: null,
    decidedAt: null,
    comment: null,
    createdAt: '2025-10-23T10:00:00+08:00',
    updatedAt: '2025-10-23T10:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'ap-012',
    brandId: 'b-001',
    campusId: 'c-002',
    type: 'COURSE_TRANSFER',
    category: 'COURSE',
    targetId: 'cu-003',
    studentId: 'cu-003',
    studentPhone: '13900000020',
    familyGroupId: 'fg-002',
    applicantId: 'u-principal-001',
    amountMinor: 0,
    currency: 'CNY',
    status: 'PENDING',
    decidedBy: null,
    decidedAt: null,
    comment: null,
    createdAt: '2025-10-23T14:00:00+08:00',
    updatedAt: '2025-10-23T14:00:00+08:00',
    createdBy: 'u-principal-001',
    updatedBy: 'u-principal-001',
  },
  {
    id: 'ap-013',
    brandId: 'b-001',
    campusId: 'c-001',
    type: 'COURSE_DROP',
    category: 'COURSE',
    targetId: 'cu-001',
    studentId: 'cu-001',
    studentPhone: '13900000001',
    familyGroupId: 'fg-001',
    applicantId: 'u-consultant-001',
    amountMinor: 45000,
    currency: 'CNY',
    status: 'REJECTED',
    decidedBy: 'u-principal-001',
    decidedAt: '2025-10-21T16:00:00+08:00',
    comment: '退课需先完成剩余课时消耗或走退费流程。',
    createdAt: '2025-10-20T15:00:00+08:00',
    updatedAt: '2025-10-21T16:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-principal-001',
  },

  // ===== 其他 =====
  {
    id: 'ap-004',
    brandId: 'b-001',
    campusId: 'c-001',
    type: 'LEAVE',
    category: 'COURSE',
    targetId: 'cu-001',
    studentId: 'cu-001',
    studentPhone: '13900000001',
    familyGroupId: 'fg-001',
    applicantId: 'u-teacher-001',
    amountMinor: 0,
    currency: 'CNY',
    status: 'PENDING',
    decidedBy: null,
    decidedAt: null,
    comment: null,
    createdAt: '2025-10-23T08:00:00+08:00',
    updatedAt: '2025-10-23T08:00:00+08:00',
    createdBy: 'u-teacher-001',
    updatedBy: 'u-teacher-001',
  },
  {
    id: 'ap-014',
    brandId: 'b-001',
    campusId: 'c-001',
    type: 'LEAVE',
    category: 'COURSE',
    targetId: 'cu-001',
    studentId: 'cu-001',
    studentPhone: '13900000001',
    familyGroupId: 'fg-001',
    applicantId: 'u-teacher-001',
    amountMinor: 0,
    currency: 'CNY',
    status: 'REJECTED',
    decidedBy: 'u-principal-001',
    decidedAt: '2025-10-20T10:00:00+08:00',
    comment: '该时段有排课，请调整请假时间。',
    createdAt: '2025-10-19T15:00:00+08:00',
    updatedAt: '2025-10-20T10:00:00+08:00',
    createdBy: 'u-teacher-001',
    updatedBy: 'u-principal-001',
  },
  {
    id: 'ap-015',
    type: 'UNFREEZE_CARD',
    status: 'PENDING',
    category: 'MEMBERSHIP',
    targetId: 'ea-003',
    studentId: 'cu-003',
    studentPhone: '13900330033',
    familyGroupId: 'fg-003',
    amountMinor: 0,
    currency: 'CNY',
    applicantId: 'u-consultant-001',
    campusId: 'c-001',
    decidedBy: null,
    decidedAt: null,
    comment: null,
    createdAt: '2025-10-19T14:00:00+08:00',
    updatedAt: '2025-10-19T14:00:00+08:00',
  },
  // ===== 合同审批（新增） =====
  {
    id: 'ap-016',
    brandId: 'b-001',
    campusId: 'c-001',
    type: 'CONTRACT_SIGN',
    category: 'CONTRACT',
    targetId: 'ct-001',
    studentId: 'cu-001',
    studentPhone: '13900000001',
    familyGroupId: 'fg-001',
    applicantId: 'u-consultant-001',
    amountMinor: 0,
    currency: 'CNY',
    status: 'PENDING',
    decidedBy: null,
    decidedAt: null,
    comment: null,
    createdAt: '2025-10-24T09:00:00+08:00',
    updatedAt: '2025-10-24T09:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'ap-017',
    brandId: 'b-001',
    campusId: 'c-002',
    type: 'CONTRACT_TERMINATE',
    category: 'CONTRACT',
    targetId: 'ct-002',
    studentId: 'cu-002',
    studentPhone: '13900220022',
    familyGroupId: 'fg-002',
    applicantId: 'u-consultant-002',
    amountMinor: 0,
    currency: 'CNY',
    status: 'APPROVED',
    decidedBy: 'u-principal-001',
    decidedAt: '2025-10-23T16:00:00+08:00',
    comment: '同意终止合同',
    createdAt: '2025-10-22T10:00:00+08:00',
    updatedAt: '2025-10-23T16:00:00+08:00',
    createdBy: 'u-consultant-002',
    updatedBy: 'u-principal-001',
  },
  // ===== 已撤回审批（新增） =====
  {
    id: 'ap-018',
    brandId: 'b-001',
    campusId: 'c-001',
    type: 'ISSUE_CARD',
    category: 'MEMBERSHIP',
    targetId: 'ea-004',
    studentId: 'cu-004',
    studentPhone: '13900440044',
    familyGroupId: 'fg-004',
    applicantId: 'u-consultant-001',
    amountMinor: 480000,
    currency: 'CNY',
    status: 'WITHDRAWN',
    decidedBy: 'u-principal-001',
    decidedAt: '2025-10-22T14:00:00+08:00',
    comment: '信息有误，已撤回修改',
    createdAt: '2025-10-21T10:00:00+08:00',
    updatedAt: '2025-10-22T15:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
]